module.exports = __webpack_public_path__ + "img/sun-solid.aa59b8a4.svg";